const MY_TASK_SUBTASK_DETAILS_PATH = '/my-task/qset-review/:taskId/subtask/:subTaskId' as const;
const TASK_MANAGEMENT_SUBTASK_DETAILS_PATH =
  '/task-management/qset-review/:taskId/subtask/:subTaskId' as const;

interface GetQSetReviewSubtaskDetailsPathParams {
  userId: string;
  subtaskAssigneeId: string;
  subtaskOwnerId: string;
  subtaskAssignerId: string;
  hasViewTaskManagementPermission: boolean;
}

/**
 * REMARK: The subtask details page is served by both the `/my-task` and the `/task-management`
 * route, each guarded by `TaskManagementPermissionRoute` with the subtask id. The reviewer
 * (subtask assignee) and the subtask assigner can only access it through `/my-task`, while the
 * subtask owner can only access it through `/task-management`.
 *
 * Returns `undefined` for users in none of those roles, since there is no route they can reach the
 * page through; callers use that to hide the entry point.
 */
export function getQSetReviewSubtaskDetailsPath({
  userId,
  subtaskAssigneeId,
  subtaskOwnerId,
  subtaskAssignerId,
  hasViewTaskManagementPermission,
}: GetQSetReviewSubtaskDetailsPathParams) {
  if (userId === subtaskAssigneeId || userId === subtaskAssignerId)
    return MY_TASK_SUBTASK_DETAILS_PATH;
  if (userId === subtaskOwnerId && hasViewTaskManagementPermission)
    return TASK_MANAGEMENT_SUBTASK_DETAILS_PATH;
}
